import { AuditResult, FullReport, Lead } from "./types";

const BASE = "https://us-central1-core6-ai-audit.cloudfunctions.net";

async function post<T>(path: string, body: object): Promise<T> {
  const res = await fetch(`${BASE}/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data as T;
}

export const api = {
  runAudit: (domain: string) => post<AuditResult>("runAudit", { domain }),
  sendReport: (auditId: string, email: string) => post<FullReport>("sendReport", { auditId, email }),
  getLeads: (password: string) => post<Lead[]>("getLeads", { password }),
  deleteLead: (password: string, id: string) => post<{ success: boolean }>("deleteLead", { password, id }),
};
